module.exports = __webpack_public_path__ + "img/eleonora_sad.cca6719e.jpeg";